document.documentElement.classList.remove('no-js');
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const open = document.body.classList.toggle('menu-open');
  toggle.setAttribute('aria-expanded', String(open));
});
document.addEventListener('keyup', (event) => {
  if (event.key === 'Escape') document.body.classList.remove('menu-open');
});
const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
  if (entry.isIntersecting) entry.target.classList.add('is-visible');
}), { threshold: .12 });
document.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
